export default {
  'bg-inherit': {
    backgroundColor: 'inherit',
  },
  'bg-current': {
    backgroundColor: 'currentColor',
  },
  'bg-transparent': {
    backgroundColor: 'transparent',
  },
  'bg-white': {
    backgroundColor: '#FFFFFF',
  },
  'bg-gray88': {
    backgroundColor: '#E0E0E0',
  },
  'bg-gray95': {
    backgroundColor: '#F2F2F2',
  },
  'bg-primary-brown': {
    backgroundColor: '#B29A74',
  },
  'bg-tertiary-brown': {
    backgroundColor: '#ECDFCF',
  },
  'bg-tertiary-blue': {
    backgroundColor: '#EAE7FE',
  },
  'bg-primary-dark': {
    backgroundColor: '#4A4A49',
  },
};
